
import React from 'react';
import { Box, Table, TableBody, TableCell, TableHeader, TableRow, Text } from 'grommet';

const DataTableHeader = ({columns}) => {
    return (
        <TableHeader>
            <TableRow>
                {columns.map(column => {
                    return (
                        <TableCell key={column.property}>
                            {column.header}
                        </TableCell>
                    );
                })}
            </TableRow>
        </TableHeader>
    );
}

const DataTableBody = ({columns, data, primaryKey}) => {
    return (
        <TableBody>
            {data.map(row => {
                return <DataTableBodyRow columns={columns} row={row} key={row[primaryKey]} />;
            })}
        </TableBody>
    );
}

const DataTableBodyRow = ({columns, row}) => {
    return (
        <TableRow>
            {columns.map(column => {
                return (
                    <TableCell key={column.property}>
                        <DataTableBodyRowCell row={row} column={column} />
                    </TableCell>
                );
            })}
        </TableRow>
    );
}

const DataTableBodyRowCell = ({column, row}) => {
    if (column.render) {
        return column.render(row);
    } else {
        return (
            <Box>
                <Text>{row[column.property]}</Text>
            </Box>
        );
    }
}

const DataTable = ({columns, data, primaryKey}) => {
    return (
        <Table style={{width: "100%"}}>
            <DataTableHeader columns={columns} />
            <DataTableBody columns={columns} data={data} primaryKey={primaryKey} />
        </Table>
    )
}

export default DataTable;


/*
        <TableRow key={item}>
            {(item === 1)
                ? (
                    <TableCell plain={true} rowSpan={numRows}>
                        <Box border="all" height={height} background={background}>
                            <Text textAlign="start">{row['nazev']}</Text>
                        </Box>
                    </TableCell>
                )

*/
